
import FileLibrary from './FileLibrary';
export default {
    data() {
        return {
            editingItemIndex: -1,
            selectedFile: { id: 0 },
        };
    },
    components: {
        FileLibrary,
    },
    methods: {
        fileLibraryOpened() { },
        fileLibraryClosed() {
            this.selectedFile = { id: 0 };
        },
        enableEditMode(index) {
            this.editingItemIndex = index;
        },
        disableEditMode() {
            this.editingItemIndex = -1;
        },
        downloadFile(file) {
            window.open(JSON.parse(file.value).secure_link, '_blank');
        },
        openAddItemPopup() {
            this.disableEditMode();
            this.selectedFile = { id: 0 };
            this.$refs.fileLibrary.openFilePickerModal();
        },
        openEditItemPopup(file, index) {
            this.enableEditMode(index);
            this.selectedFile = JSON.parse(file.value);
            setTimeout(() => {
                this.$refs.fileLibrary.openFilePickerModal();
            }, 100);
        },
        getFontAwesomeIconFromMIME(mimeType) {
            if (!mimeType) {
                return 'fa-file';
            }
            const icon_classes = {
                // Media
                image: 'fa-image',
                audio: 'fa-file-audio',
                video: 'fa-file-video',
                // Documents
                'application/pdf': 'fa-file-pdf',
                'application/msword': 'fa-file-word',
                'application/vnd.ms-word': 'fa-file-word',
                'application/vnd.oasis.opendocument.text': 'fa-file-word',
                'application/vnd.openxmlformats-officedocument.wordprocessingml':
                    'fa-file-word',
                'application/vnd.ms-excel': 'fa-file-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml':
                    'fa-file-excel',
                'application/vnd.oasis.opendocument.spreadsheet': 'fa-file-excel',
                'application/vnd.ms-powerpoint': 'fa-file-powerpoint',
                'application/vnd.openxmlformats-officedocument.presentationml':
                    'fa-file-powerpoint',
                'application/vnd.oasis.opendocument.presentation': 'fa-file-powerpoint',
                'text/plain': 'fa-file-alt',
                'text/html': 'fa-file-code',
                'application/json': 'fa-file-code',
                // Archives
                'application/gzip': 'fa-file-archive',
                'application/zip': 'fa-file-archive',
            };

            for (const key in icon_classes) {
                if (icon_classes.hasOwnProperty(key)) {
                    if (mimeType.search(key) === 0) {
                        // Found it
                        return icon_classes[key];
                    }
                } else {
                    return 'fa-file';
                }
            }

            return 'fa-file';
        },
    },
}